export default {
  reference_number: "Ref. No.",
  article_number: "Art. No.",
  hrs: "hrs",
  mins: "mins",
  hr: "hr",
  min: "min",
  operators: ["contains", "endsWith", "eq", "ncontains", "nendsWith", "neq", "nstartsWith", "startsWith"],
};
